import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import ActionsList from 'mutation/components/declaration-cohabitation/actions-list';
import { SearchPersonCohabitationCrumbs } from 'mutation/constants/declaration-cohabitation-crumbs';

const PersonsPage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={SearchPersonCohabitationCrumbs} />
      <PersonSearch
        pathname="/mutazioni/persona/convivenza/dichiarazione"
        action={ActionsList}
        addedTitle={'- Dichiarazione Convivenza'}
      />
    </Fragment>
  );
};

PersonsPage.displayName = 'Persons page component';

export default PersonsPage;
